import { useBloc } from "@blac/react";
import styled from "@emotion/styled";
import type { FC } from "react";
import React from "react";
import { APP_BREAKPOINT } from "src/constants/layout";
import { LoincCodingCode } from "src/constants/fhir";
import translate from "src/lib/translate";
import Translate from "src/ui/components/Translate/Translate";
import type { Progress } from "./DataHubCubit";
import DataHubCubit, { ChartUnits } from "./DataHubCubit";
import { renderTimeRangeContext } from "./DataTimeRangeButtons";

//#region Styled components
const Wrapper = styled.div`
  margin: 0 0 1rem;

  @media screen and (min-width: ${APP_BREAKPOINT}px) {
    margin: 0 0 1.25rem;
  }
`;

const FlexContainer = styled.div`
  display: flex;
  gap: 0.25rem;

  p {
    margin: 0;
    font-weight: 500;
    font-size: 1.125rem;

    @media screen and (min-width: ${APP_BREAKPOINT}px) {
      font-size: 1.25rem;
    }
  }
`;

const TimeRange = styled.p`
  color: var(--color-charcoal);
`;

const Progress = styled.p`
  color: var(--color-charcoal-60);
`;
//#endregion

const DataStatus: FC = () => {
  const [
    { activeTimeRange, activeProgress, activeLoincCode },
    { formatValueDataStatus, formatBloodGlucoseProgress }
  ] = useBloc(DataHubCubit);

  if (activeProgress?.difference === undefined || !activeProgress?.unit) {
    return null;
  }

  const { difference, unit } = activeProgress;

  const renderProgressValue = () => {
    if (activeLoincCode === LoincCodingCode.bloodGlucoseCapillary) {
      return formatBloodGlucoseProgress(difference);
    }

    return (
      <>
        {formatValueDataStatus(difference, unit)}
        {unit}
        {unit === ChartUnits.steps && (
          <Translate msg="chart.average" variables={{ context: "perDay" }} />
        )}
      </>
    );
  };

  return (
    <Wrapper className="status">
      <FlexContainer>
        <TimeRange>
          {translate("timeRange.long", {
            context: renderTimeRangeContext(activeTimeRange?.domain)
          })}
        </TimeRange>

        <Progress>
          {activeProgress.secondaryDifference !== undefined ? (
            <>
              {formatValueDataStatus(
                activeProgress.difference,
                activeProgress.unit
              )}
              /
              {formatValueDataStatus(
                activeProgress.secondaryDifference,
                activeProgress.unit
              )}
              {activeProgress.unit}
            </>
          ) : (
            renderProgressValue()
          )}
        </Progress>
      </FlexContainer>
    </Wrapper>
  );
};

export default DataStatus;
